import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircle } from 'lucide-react';
export function AgitationSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  return <section ref={ref} className="bg-slate-50 py-16 px-4" data-id="element-12">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} animate={isInView ? {
      opacity: 1,
      y: 0
    } : {}} transition={{
      duration: 0.6
    }} className="max-w-4xl mx-auto" data-id="element-13">
        <div className="flex items-center justify-center mb-6" data-id="element-14">
          <XCircle className="w-12 h-12 text-red-500" data-id="element-15" />
        </div>
        <p className="text-lg md:text-xl text-slate-700 leading-relaxed mb-6" data-id="element-16">
          You've tried the Kongs. You've tried leaving the TV on. You've even
          tried those "calming treats" that cost a fortune and did absolutely
          nothing.
        </p>
        <p className="text-lg md:text-xl text-slate-700 leading-relaxed mb-6" data-id="element-17">
          Meanwhile, your neighbors are complaining, your door frames are
          ruined, and the guilt is eating you alive.
        </p>
        <p className="text-xl md:text-2xl font-semibold text-slate-900 text-center" data-id="element-18">
          It's not your dog's fault, and it's not yours either. But "waiting for
          him to grow out of it" is a recipe for a destroyed home and a
          miserable pet.
        </p>
      </motion.div>
    </section>;
}